import { Box, MenuItem, Skeleton } from '@mui/material';
import { ATSAutomationCreateTestIds } from 'data-testids/ATS';

import { ErrorText } from 'features/Automations/styles';
import { EmailCandidateProps } from 'features/Automations/types';
import { useFormContext } from 'react-hook-form';
import {
  useQueryGetEmailTemplateListData,
  useQueryGetSuperAndDistrictAdminsData,
} from 'features/Automations/api/listQueries';
import auth from 'utils/auth';
import { AutomationDropdown } from './AutomationDropdown';

export const EmailCandidate: React.FC<EmailCandidateProps> = ({ automationIndex }) => {
  const userId = auth.getUser()?.id;
  const districtId = auth.getUser()?.district?.id;
  const { data: emailTemplates, isLoading: isEmailTemplatesLoading } =
    useQueryGetEmailTemplateListData(userId);
  const { data: superAndDistrictAdmins, isLoading: isAdminsLoading } =
    useQueryGetSuperAndDistrictAdminsData(districtId);
  const isLoading = isEmailTemplatesLoading || isAdminsLoading;
  const {
    watch,
    formState: { errors },
  } = useFormContext();

  const hasSelectedSender = watch(`automations.${automationIndex}.email.sender`);
  const hasSelectedEmailTemplate = watch(`automations.${automationIndex}.email.email_template_id`);
  const hasSelectedEmailProperty = Boolean(hasSelectedSender) || Boolean(hasSelectedEmailTemplate);

  const errorMessage =
    errors?.automations?.[automationIndex]?.email?.email_template_id?.message ||
    errors?.automations?.[automationIndex]?.email?.sender?.message;

  return (
    <>
      {isLoading ? (
        <Skeleton
          data-testid={ATSAutomationCreateTestIds.EMAIL_LOADING_SKELETON}
          variant="rectangular"
          sx={{ height: 50 }}
        />
      ) : (
        <Box>
          Send
          <AutomationDropdown
            dataTestId={ATSAutomationCreateTestIds.EMAIL_TEMPLATE_SELECT}
            name={`automations.${automationIndex}.email.email_template_id`}
            defaultValue={null}
            isRequired={hasSelectedEmailProperty ? 'Please select an email template' : false}
          >
            <MenuItem value="" disabled>
              Email template
            </MenuItem>
            {emailTemplates?.map((emailTemplate) => (
              <MenuItem key={emailTemplate.id} value={emailTemplate.id}>
                {emailTemplate.title}
              </MenuItem>
            ))}
          </AutomationDropdown>
          from
          <AutomationDropdown
            dataTestId={ATSAutomationCreateTestIds.EMAIL_SENDER_SELECT}
            name={`automations.${automationIndex}.email.sender`}
            defaultValue={null}
            isRequired={hasSelectedEmailProperty ? 'Please select a sender' : false}
          >
            <MenuItem value="" disabled>
              sender
            </MenuItem>
            {superAndDistrictAdmins?.map((admin) => (
              <MenuItem key={admin.id} value={admin.id}>
                {admin.name}
              </MenuItem>
            ))}
          </AutomationDropdown>
          24 hours after status change
        </Box>
      )}
      <ErrorText data-testid={ATSAutomationCreateTestIds.EMAIL_ERROR_MESSAGE}>
        {errorMessage}
      </ErrorText>
    </>
  );
};
